import React, { useEffect, useState } from "react";
import { getAsmtById } from "../../services/authService";
import { useParams } from "react-router-dom";
import { decodeId } from "../../utills/idUtils";

const ReportStaticPart1 = ({ isGeneratingPdf }) => {
  const { encodedId } = useParams();
  const id = decodeId(encodedId);
  const [assessmentType, setAssessmentType] = useState(null); // State to store the assessment type

  useEffect(() => {
    const fetchAsmtType = async () => {
      const asmtData = await getAsmtById(id);
      setAssessmentType(asmtData.assessment_type);
    };

    if (id) {
      fetchAsmtType();
    }
  }, [id]);

  const styles = {
    container: {
      fontFamily: "Helvetica, Arial, sans-serif",
      padding: "20px",
      margin: "0 auto",
      maxWidth: "900px",
    },
    heading: {
      fontSize: "24px",
      fontWeight: "bold",
      marginBottom: "20px",
    },
    subheading: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "15px",
    },
    paragraph: {
      fontSize: "16px",
      lineHeight: "1.5",
      marginBottom: "15px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginBottom: "20px",
    },
    tableRow: {
      borderBottom: "1px solid #ddd",
      padding: "8px 0",
    },
    tableCell: {
      padding: "8px 12px",
      verticalAlign: "top",
    },
    numberCell: {
      fontWeight: "bold",
      textAlign: "center",
    },
    textCell: {
      textAlign: "left",
    },
    list: {
      listStyleType: "decimal",
      paddingLeft: "20px",
      marginBottom: "15px",
    },
    listItem: {
      fontSize: "16px",
      marginBottom: "5px",
    },
  };

  return (
    <>
        <div className="p-4 lg:px-16">
                    <div style={{pageBreakAfter:'always'}}></div>

          <div class="  rounded-lg bg-gray-200 p-3 lg:p-10 pr-8">

            <h3
              class=" font-bold lg:text-5xl text-3xl mb-4"
              style={{ fontFamily: "Helvetica" , fontSize: "25px",}}
            >
              Overview of Your Executive Presence
            </h3>
            <p class="mb-4" style={{ fontFamily: "Helvetica",fontSize: "15px", }}>
              {assessmentType === "self" ? (
                <>
                  This report offers a comprehensive view of your Executive
                  Presence, based on your self-assessment. It evaluates seven
                  key elements that define Executive Presence, providing
                  insights into your performance through consolidated scores and
                  detailed feedback on specific questions within each element.
                </>
              ) : (
                <>
                  {" "}
                  This report provides a comprehensive view of your Executive
                  Presence based on feedback from you (self) and from your
                  selected respondents (colleagues, managers, team members, or
                  friends). The assessment evaluates seven key elements that
                  define Executive Presence, with insights drawn from both the
                  consolidated average scores and detailed feedback on specific
                  questions within each element.
                </>
              )}
            </p>
            <h3
              class="lg:text-4xl text-3xl font-bold py-2 mb-2"
              style={{ fontFamily: "Helvetica" ,fontSize: "25px",}}  
            >
              Executive Presence key elements assessed are:
            </h3>
            <table
              className="list-decimal list-inside space-y-2"
              style={{ borderSpacing: "0 12px", fontFamily: "Helvetica" }}
            >
              <tbody style={{ fontFamily: "Helvetica", fontSize: "15px" }}>
                <tr style={{fontFamily: "Helvetica" }} >
                  {/* <td style={styles.numberCell}>1.</td> */}
                  <td style={styles.textCell}>
                    <strong>1. Communication</strong> - The ability to clearly
                    explain and present ideas in a way that captures attention
                    and inspires enthusiasm.
                  </td>
                </tr>
                <tr style={{ fontFamily: "Helvetica", fontSize: "15px" }}>
                  {/* <td style={styles.numberCell}>2.</td> */}
                  <td style={styles.textCell}>
                    <strong>2. Charisma</strong> - A positive aura and a commanding
                    presence!
                  </td>
                </tr>
                {/* <tr>
              <td style={styles.numberCell}>3.</td>
              <td style={styles.textCell}>
                <strong>Confidence</strong> - Faith in their abilities and judgment.
                Can voice unpopular opinions and stick to their stand.
              </td>
            </tr> */}
                <tr style={{ fontFamily: "Helvetica", fontSize: "15px" }}>
                  {/* <td style={styles.numberCell}>3.</td> */}
                  <td style={styles.textCell}>
                    <strong>3. Collaboration</strong> - A we-centric approach,
                    always willing to work with others and offer support
                    whenever needed.
                  </td>
                </tr>
                <tr style={{ fontFamily: "Helvetica" , fontSize: "15px"}}>
                  {/* <td style={styles.numberCell}>4.</td> */}
                  <td style={styles.textCell}>
                    <strong>4. Composure</strong> - The ability to stay calm and
                    composed during challenging times.
                  </td>
                </tr>
                <tr style={{ fontFamily: "Helvetica", fontSize: "15px" }}>
                  {/* <td style={styles.numberCell}>5.</td> */}
                  <td style={styles.textCell}>
                    <strong>5. Clarity</strong> - Having a clear understanding of
                    their strengths, internal drivers, key values, and desired
                    outcomes.
                  </td>
                </tr>
                <tr style={{ fontFamily: "Helvetica", fontSize: "15px" }}>
                  {/* <td style={styles.numberCell}>6.</td> */}
                  <td style={styles.textCell}>
                    <strong>6. Connection</strong> - The ability to empathize and
                    establish long-term, sustainable relationships.
                  </td>
                </tr>
                <tr style={{ fontFamily: "Helvetica" , fontSize: "15px"}}>
                  {/* <td style={styles.numberCell}>7.</td> */}
                  <td style={styles.textCell}>
                    <strong>7. Courage</strong> - The ability to stand up for what
                    they believe is right.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className=" rounded-lg ">
              <h1
                className="lg:text-4xl text-3xl py-2 font-bold mt-4"
                style={{ fontFamily: "Helvetica", fontSize: "25px" }}
              >
                Understanding Your Executive Presence Assessment Report
              </h1>
              {assessmentType === "self" ? (
                <p style={{ fontFamily: "Helvetica" , fontSize: "15px"}}>
                  Your Self-Assessment report is designed to offer a holistic
                  view of how you perceive yourself across key areas critical to
                  Executive Presence. The report is divided into four sections,
                  providing a clear and detailed breakdown of your strengths and
                  areas for growth.
                </p>
              ) : (
                <p className="mt-4" style={{ fontFamily: "Helvetica" , fontSize: "15px"}}>
                  Your 360 degree Executive Presence assessment is designed to
                  provide a holistic view of how you are perceived across key
                  areas critical to Executive Presence. This report is divided
                  into four sections to give you a clear, detailed breakdown of
                  your strengths and opportunities for growth.
                </p>
              )}
              <p className="mt-4" style={{ fontFamily: "Helvetica", fontSize: "15px"}}>
                The assessment scores are based on a Likert scale where
                responses are categorized as:
              </p>
              <ul className="mt-4" style={{ fontFamily: "Helvetica" , fontSize: "15px"}}>
                <li>Strongly Agree (5)</li>
                <li>Agree (4)</li>
                <li>Neutral (3)</li>
                <li>Disagree (2)</li>
                <li>Strongly Disagree (1)</li>
              </ul>
              <br></br>
              <p style={{ fontFamily: "Helvetica" ,fontSize: "15px",}}>
                Each element of the assessment is evaluated based on this scale.
                Additionally, within each element, there is a final question
                designed to identify potential derailers. Responses to this
                question negatively impacts the overall score for that element.
              </p>
            </div>

          </div>
        </div>
    
  
     
      
    </>
  );
};

export default ReportStaticPart1;
